export const ymd = (d) => d.toLocaleDateString("en-CA");

export const lastDays = (n) => Array.from({ length: n }, (_, i) => {
  const d = new Date();
  d.setDate(d.getDate() - (n - 1 - i));
  return d;
});

const DAY_MS = 86400000;
const atNoon = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 12);

// first 14 days from creation while the habit is younger than 14 days, then the last 14 ending today
export function stripDays(createdAt) {
  const start = atNoon(new Date(createdAt));
  const today = atNoon(new Date());
  const age = Math.round((today - start) / DAY_MS);
  const first = age < 14 ? start : new Date(today.getTime() - 13 * DAY_MS);
  return { early: age < 14, days: Array.from({ length: 14 }, (_, i) => atNoon(new Date(first.getTime() + i * DAY_MS))) };
}

const INITIALS = ["D", "L", "M", "M", "J", "V", "S"];
export const dayInitial = (d) => INITIALS[d.getDay()];

export const nextStatus = (s) => (s === "si" ? "no" : s === "no" ? null : "si");

// consecutive "si" days ending today (or yesterday if today is unmarked)
export function streak(byDate) {
  const d = new Date();
  if (!byDate[ymd(d)]) d.setDate(d.getDate() - 1);
  let n = 0;
  for (; byDate[ymd(d)] === "si"; d.setDate(d.getDate() - 1)) n += 1;
  return n;
}

export function lastMonth(byDate, createdAt) {
  const start = ymd(new Date(createdAt));
  const days = lastDays(30).map(ymd).filter((k) => k >= start);
  return { done: days.filter((k) => byDate[k] === "si").length, total: days.length };
}

export const habitLabel = (h) => {
  const since = new Date(h.created_at).toLocaleDateString("es-MX", { day: "numeric", month: "long" });
  return `${h.type === "cambiar" ? "Cambio" : "Hábito nuevo"} · desde el ${since}`;
};

export const STRIPES = { backgroundImage: "repeating-linear-gradient(45deg, var(--borde) 0 2px, transparent 2px 7px)" };
